import PropTypes from 'prop-types';

function normalizePreviewValue(value) {
    if (value == null || value === '') return '';

    if (Array.isArray(value)) {
        return JSON.stringify(value);
    }

    if (typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }

    const text = String(value).trim();
    if (!text) return '';

    const firstChar = text[0];
    const lastChar = text[text.length - 1];
    const seemsJson = (firstChar === '{' && lastChar === '}') || (firstChar === '[' && lastChar === ']');

    if (seemsJson) {
        try {
            const parsed = JSON.parse(text);
            return JSON.stringify(parsed);
        } catch {
            return text;
        }
    }

    return text;
}

function truncate(text, maxLength) {
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength)}…`;
}

export default function TableCellPreview({
    value,
    maxLength = 64,
    emptyLabel = '-',
    mono = false,
    className = '',
}) {
    const fullText = normalizePreviewValue(value);

    if (!fullText) {
        return <span className="text-zinc-400">{emptyLabel}</span>;
    }

    const shortText = truncate(fullText, maxLength);

    return (
        <span
            title={fullText}
            className={`inline-block max-w-[28rem] truncate align-middle ${mono ? 'font-mono text-xs' : ''} ${className}`}
        >
            {shortText}
        </span>
    );
}

TableCellPreview.propTypes = {
    value: PropTypes.any,
    maxLength: PropTypes.number,
    emptyLabel: PropTypes.string,
    mono: PropTypes.bool,
    className: PropTypes.string,
};
